<template>
  <div class="m-auto d-flex form-container">
    <div style="z-index: 0">
      <nk-date :options="{ pickerEnabled: true, pickerCss: 'btn btn-default', }" v-model="currentValue" @update:modelValue="onInputBoxChanged" ref="datePicker" />
    </div>
    <div class="mr-2 mt-1 d-flex" style="">
      <a class="input-button m-auto" style="" data-clear>
        <i class="fa fa-times " style="cursor:pointer" v-on:click="removeFilter"></i>
      </a>
    </div>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        currentValue: null,
      }
    },
    methods: {
      removeFilter() {
        // this.$refs.datePicker.setDefault(null)
        this.currentValue = null
        this.onInputBoxChanged()
      },
      onInputBoxChanged() {
        if (this.currentValue === '') {
          // Remove the filter
          this.params.parentFilterInstance((instance) => {
            instance.myMethodForTakingValueFromFloatingFilter(null)
          })
          return
        }

        this.params.parentFilterInstance((instance) => {
          instance.myMethodForTakingValueFromFloatingFilter(this.currentValue)
        })
      },

      onParentModelChanged(parentModel) {
        // When the filter is empty we will receive a null value here
        if (parentModel == null) {
          this.currentValue = ''
        } else {
          this.currentValue = parentModel
        }
      },
    },
  }
</script>
